module.exports = __webpack_public_path__ + "static/media/basketball-header.0cd45233.png";